import React from "react";
import Navbar2 from "../Components/Navbar2";

function BasketballRates() {
  return (
    <>
    <Navbar2 />
      <div className="container-fluid px-0 pb-4 pt-5">
        <div className="row text-center">
          <div className="col">
            <div className="h1">
              BASKETBALL RATES
            </div>
          </div>
        </div>
      </div>
      <div className="container my-5">
        <h3 className="mb-4 h1 text-center">Private Training</h3>
      
      <div className="row g-4">

        {/* John Hollmon */}
        <div className="col-12 col-md-6 col-lg-4">
          <div className="card h-100">
            <div className="card-body">
              <h5 className="card-title fw-bold">John Hollmon</h5>
              <p className="card-text">$225 per session</p>
            </div>
          </div>
        </div>

        {/* Brian Hall */}
        <div className="col-12 col-md-6 col-lg-4">
          <div className="card h-100">
            <div className="card-body">
              <h5 className="card-title fw-bold">Brian Hall</h5>
              <ul className="card-text list-unstyled mb-0">
                <li>$150 per session</li>
                <li>$500 package of 4</li>
                <li>$1000 package of 8</li>
              </ul>
            </div>
          </div>
        </div>
        {/* Kesean Warren */}
        <div className="col-12 col-md-6 col-lg-4">
          <div className="card h-100">
            <div className="card-body">
              <h5 className="card-title fw-bold">Kesean Warren</h5>
              <ul className="card-text list-unstyled mb-0">
                <li>$100 per session</li>
                <li>$475 package of 5</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Semi-Private */}
        <div className="col-12 col-md-6 col-lg-4">
          <div className="card h-100 bg-light">
            <div className="card-body">
              <h5 className="card-title fw-bold">
                Semi-Private Training <small className="text-muted"><br/>(2–5 players)</small>
              </h5>
              <p className="card-text">$90 per player</p>
              <p className="card-text">***Rates DO NOT apply to professional athletes.</p>
            </div>
          </div>
        </div>

        {/* Group Training */}
        <div className="col-12 col-md-6 col-lg-4">
          <div className="card h-100 bg-light">
            <div className="card-body">
              <h5 className="card-title fw-bold">
                Group Training<br/> <small className="text-muted">(5+ players)</small>
              </h5>
              <p className="card-text">$75 per hour</p>
              <p className="card-text">***Rates DO NOT apply to professional athletes.</p>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div className="container-fluid pb-4">
      <div className="row text-center">
        <div className="col">
          <div className="h1">
          Train like a Pro!
        </div>
        </div>
      </div>
      <div className="container my-3">
        <div className="row g-4">
          <div className="col-12 col-sm-6 col-lg-3">
            <div className="vertical-video-container">
              <video className="position-absolute top-0 start-0 w-100 h-100" controls playsInline>
                <source src="./s3/day1_1.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-lg-3">
            <div className="vertical-video-container">
              <video className="position-absolute top-0 start-0 w-100 h-100" controls playsInline>
                <source src="./s3/day1_2.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-lg-3">
            <div className="vertical-video-container">
              <video className="position-absolute top-0 start-0 w-100 h-100" controls playsInline>
                <source src="./s3/day2_1.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-lg-3">
            <div className="vertical-video-container" >
              <video className="position-absolute top-0 start-0 w-100 h-100" controls playsInline>
                <source src="./s3/day2_2.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);
}

export default BasketballRates;
